import { useSystemBanners } from "@portal/providers/SystemBannerProvider";
import { Banner } from "../../primitives/Banner";

export const SystemBanners = ({ className }: { className?: string }) => {
	const { banners } = useSystemBanners();

	if (banners.length === 0) return null;

	return (
		<div className={className}>
			{banners.map((banner) => (
				<Banner key={banner.id} tone={banner.tone}>
					<Banner.Content>{banner.message}</Banner.Content>
				</Banner>
			))}
		</div>
	);
};
